// Normaliza texto para búsquedas: minúsculas, sin tildes, sin espacios extra.
// Se aplica tanto al término tecleado como a cada campo del registro. Es la
// contrapartida en cliente de f_unaccent(lower(...)) en SQL.
export function normalize(input: string | null | undefined): string {
  if (!input) return "";
  return input
    .toString()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // strip diacríticos
    .toLowerCase()
    .trim();
}

/**
 * Match "cualquier orden, cualquier campo": divide el término por espacios y
 * exige que cada palabra aparezca (como substring) en alguno de los campos.
 * Ej: "karsell junio" encuentra un registro con cliente "Karseell" y notas
 * que contengan "junio", sin importar en qué campo esté cada palabra.
 */
export function matchesQuery(query: string, fields: Array<string | null | undefined>): boolean {
  const q = normalize(query);
  if (!q) return true;
  const words = q.split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = fields.map(normalize).filter(Boolean).join(" ");
  return words.every((w) => haystack.includes(w));
}
